"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));

var SearchBar = function SearchBar(_ref) {
  var onSearch = _ref.onSearch;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "navigation-search-bar"
  }, /*#__PURE__*/_react["default"].createElement(_InputBase["default"], {
    placeholder: "Search...",
    onChange: onSearch
  }));
};

SearchBar.propTypes = {
  onSearch: _propTypes["default"].func
};

var _default = (0, _react.memo)(SearchBar);

exports["default"] = _default;